class TeaserList{
    constructor(el) {
        this.scope = el;
        this.items = el.querySelector('[data-items]');
        this.prevButton = el.querySelector('[data-prev]');
        this.nextButton = el.querySelector('[data-next]');
        this.count = el.querySelector("[data-count]");
        if(this.items != null && this.items.children != null) {
            if (this.items.children.length > 1) {
                this.slider = new Slider(this.scope, this.items, [this.prevButton, this.nextButton]);
                this.scope.classList.add("list-teasers-2--loaded");
                this.bindEvents();
            }
        }

    }

    bindEvents(){
        if(viewport() === 0){
            this.updateCount(
                Slider.getSlideCount(this.slider.sliderObject.getInfo()).detail.count,
                Slider.getSlideCount(this.slider.sliderObject.getInfo()).detail.visible,
                Slider.getSlideCount(this.slider.sliderObject.getInfo()).detail.index
            );
        }
        this.scope.addEventListener("change", e=>{
            if(viewport() === 0){
                this.updateCount(
                    e.detail.count,
                    e.detail.visible,
                    e.detail.index
                )
            }
        })
    }

    updateCount(count, visible, index){
        //override tns tabindex
        this.prevButton.setAttribute("tabindex", "0");
        this.nextButton.setAttribute("tabindex", "0");
        if(visible===count){
            this.count.style.display = "none";
        }else{
            this.count.style.display = "";
            SliderControls.updateCount(this.count, count, visible, index);
        }
    }
}


ControlBinders.register(`[data-teaser-list]`, el => new TeaserList(el));